import { render } from "./MessageToolsDrawer.vue?vue&type=template&id=c89f85f0&scoped=true"
import script from "./MessageToolsDrawer.vue?vue&type=script&lang=js"
export * from "./MessageToolsDrawer.vue?vue&type=script&lang=js"

import "./MessageToolsDrawer.vue?vue&type=style&index=0&id=c89f85f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89f85f0"]])

export default __exports__